<div class="client-payment-profile-dropdown--container">
  <div class="lum-label">Select Payment Profile</div>
  <mat-select
    class="lum-select"
    [formControl]="cardControl"
    (selectionChange)="onSelect($event)"
  >
    <mat-option [value]="null" disabled>Choose Payment Profile</mat-option>
    <mat-option
      *ngFor="let card of creditCards; trackBy: trackById"
      [value]="card.id"
    >
      {{ card.label }}
    </mat-option>
  </mat-select>
</div>
